import { render, staticRenderFns } from "./recommendations.vue?vue&type=template&id=f53f6c5a&"
import script from "./recommendations.vue?vue&type=script&lang=ts&"
export * from "./recommendations.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports